"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }

var _protocol = require('./protocol');
var _contactCap = require('shared/services/contactCap');























 class SessionRestartError extends Error {
  constructor (message = 'Upload session must be restarted') {
    super(message)
    this.name = 'SessionRestartError'
  }
} exports.SessionRestartError = SessionRestartError;

// Thrown when the server can't take direct uploads (kill switch or an older
// server). The caller falls back to /upload_file.
 class DirectUploadUnavailableError extends Error {
  constructor () {
    super('Direct upload unavailable')
    this.name = 'DirectUploadUnavailableError'
  }
} exports.DirectUploadUnavailableError = DirectUploadUnavailableError;

// Every byte is in GCS but the native uploader couldn't complete the upload.
// uploadDirect then tries CompleteUpload over the socket; if that fails too,
// the message isn't sent. Retryable: CompleteUpload can still finish it
// later (not after a final 410/422 refusal).
 class UploadNotSentError extends Error {
  constructor ( reason,  retryable = true) {
    super(`Upload not sent: ${reason}`);this.reason = reason;this.retryable = retryable;
    this.name = 'UploadNotSentError'
  }
} exports.UploadNotSentError = UploadNotSentError;

 class DirectUploadAbortedError extends Error {
  constructor () {
    super('Upload aborted')
    this.name = 'AbortError'
  }
} exports.DirectUploadAbortedError = DirectUploadAbortedError;

// After the server says no, don't ask again for a while.
const UNAVAILABLE_RETRY_MS = 10 * 60000
let unavailableUntil = 0

 const directUploadMaybeAvailable = (now = Date.now()) => now >= unavailableUntil; exports.directUploadMaybeAvailable = directUploadMaybeAvailable

 const resetDirectUploadAvailability = () => {
  unavailableUntil = 0
}; exports.resetDirectUploadAvailability = resetDirectUploadAvailability

const MAX_SESSION_RESTARTS = 3
// Complete answers "upload is finishing" while another finalize runs, and
// "upload is not finished" when GCS hasn't made the object visible yet.
const COMPLETE_RETRY_ERRORS = new Set(['upload is finishing', 'upload is not finished'])
const COMPLETE_ATTEMPTS = 6
const COMPLETE_RETRY_MS = 1500

const wait = (ms) => new Promise(resolve => setTimeout(resolve, ms))

const errorText = (err) =>
  err && typeof err === 'object' ? (err ).Error : undefined




























 const USER_UPLOAD_COMMANDS = { start: 'StartUpload', complete: 'CompleteUpload', cancel: 'CancelUpload' }; exports.USER_UPLOAD_COMMANDS = USER_UPLOAD_COMMANDS
 const PATIENT_UPLOAD_COMMANDS = {
  start: 'StartPatientUpload', complete: 'CompletePatientUpload', cancel: 'CancelPatientUpload',
}; exports.PATIENT_UPLOAD_COMMANDS = PATIENT_UPLOAD_COMMANDS

// Uploads one file straight to GCS and returns the stored file. For a message
// upload the server has posted the message by the time this resolves.
 const uploadDirect = async ({
  send, transport, request, onProgress = () => undefined, onStarted, onLanded, previousUploadKey, signal,
  completeRetryMs = COMPLETE_RETRY_MS, commands = exports.USER_UPLOAD_COMMANDS,
}) => {
  if (_optionalChain([signal, 'optionalAccess', _ => _.aborted])) throw new DirectUploadAbortedError()

  let uploadKey = previousUploadKey
  const cancelServerSession = () => {
    if (uploadKey) send(commands.cancel , { UploadKey: uploadKey }).catch(() => undefined)
  }
  // Rejects as soon as the signal aborts, whatever is in progress.
  let rejectAborted = () => undefined
  const aborted = new Promise((_resolve, reject) => { rejectAborted = reject })
  aborted.catch(() => undefined)
  const onAbort = () => {
    if (uploadKey) transport.cancel(uploadKey).catch(() => undefined)
    cancelServerSession()
    rejectAborted(new DirectUploadAbortedError())
  }
  _optionalChain([signal, 'optionalAccess', _2 => _2.addEventListener, 'optionalCall', _3 => _3('abort', onAbort)])
  const untilAborted = (promise) => Promise.race([promise, aborted])

  // Set when the transport completed the upload itself.
  let completed
  // Set when the bytes landed but the transport couldn't complete them.
  let notSent
  try {
    for (let restarts = 0; ; restarts++) {
      let started = null
      try {
        const starting = send(commands.start , request)
        // Aborted while starting: cancel the session once it exists.
        starting.then(result => {
          if (_optionalChain([signal, 'optionalAccess', _4 => _4.aborted])) send(commands.cancel , { UploadKey: result.UploadKey }).catch(() => undefined)
        }, () => undefined)
        started = await untilAborted(starting)
      } catch (err) {
        if (err instanceof DirectUploadAbortedError) throw err
        if (_protocol.isDirectUploadUnavailable.call(void 0, err)) {
          if (_protocol.isDirectUploadDisabled.call(void 0, err)) unavailableUntil = Date.now() + UNAVAILABLE_RETRY_MS
          // Switched off after bytes went out: close the old session.
          cancelServerSession()
          throw new DirectUploadUnavailableError()
        }
        // A restart or Retry finds every byte already in GCS, or the upload
        // already finalized: go straight to complete (it returns the file).
        if (!(uploadKey && (_protocol.isUploadAlreadyReceived.call(void 0, err) || errorText(err) === 'upload already completed'))) throw err
      }
      if (started) {
        uploadKey = started.UploadKey
        if (_optionalChain([signal, 'optionalAccess', _5 => _5.aborted])) {
          onAbort()
          throw new DirectUploadAbortedError()
        }
        _optionalChain([onStarted, 'optionalCall', _6 => _6(uploadKey)])
        try {
          completed = (await untilAborted(transport.upload(started, onProgress))) || undefined
        } catch (err) {
          if (err instanceof DirectUploadAbortedError || _optionalChain([signal, 'optionalAccess', _7 => _7.aborted])) throw new DirectUploadAbortedError()
          if (err instanceof SessionRestartError && restarts < MAX_SESSION_RESTARTS) continue
          // The bytes are in GCS: complete over the socket instead.
          if (err instanceof UploadNotSentError && err.retryable) {
            notSent = err
            break
          }
          // A permanent failure will never complete: close the session. A
          // retryable message upload stays open so a retry can restart it
          // (same MessageKey); a file upload is never resumed, so close it.
          if (!isRetryable(err) || request.Purpose === 'file') cancelServerSession()
          throw err
        }
      }
      break
    }
    _optionalChain([onLanded, 'optionalCall', _8 => _8()])
    if (completed) return completed
    try {
      const file = await untilAborted(exports.completeWithRetry.call(void 0, send, uploadKey, completeRetryMs, commands.complete))
      if (notSent) _optionalChain([transport, 'access', _9 => _9.completedElsewhere, 'optionalCall', _10 => _10(uploadKey)])
      return file
    } catch (err) {
      if (request.Purpose === 'file' && !(err instanceof DirectUploadAbortedError)) cancelServerSession()
      // Still not sent: report it as such, not as the socket's answer;
      // except a contact-cap refusal, which the message row explains.
      if (notSent && !(err instanceof DirectUploadAbortedError) && !_contactCap.contactCapBlockFromError.call(void 0, err)) throw notSent
      throw err
    }
  } finally {
    _optionalChain([signal, 'optionalAccess', _11 => _11.removeEventListener, 'optionalCall', _12 => _12('abort', onAbort)])
  }
}; exports.uploadDirect = uploadDirect

const isRetryable = (err) =>
  err instanceof SessionRestartError ||
  (!!err && typeof err === 'object' && (err ).retryable === true)

// CompleteUpload, retried while the server is finishing it (or GCS hasn't
// shown the object yet).
 const completeWithRetry = async (
  send, uploadKey, retryMs = COMPLETE_RETRY_MS, command = exports.USER_UPLOAD_COMMANDS.complete,
) => {
  for (let attempt = 1; ; attempt++) {
    try {
      return await send(command , { UploadKey: uploadKey })
    } catch (err) {
      const text = errorText(err)
      if (typeof text !== 'string' || !COMPLETE_RETRY_ERRORS.has(text) || attempt >= COMPLETE_ATTEMPTS) throw err
      await wait(retryMs)
    }
  }
}; exports.completeWithRetry = completeWithRetry
